export const DsfPolicyInterpretationList = dsf.defineAsyncComponent("DsfPolicyInterpretationList", () => import("./InterpretationList.vue"));
export const DsfPolicyInterpretationDetail = dsf.defineAsyncComponent("DsfPolicyInterpretationDetail", () => import("./InterpretationDetail.vue"));
